import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle.svg'
import _imports_1 from '@/app/ui/assets/svg/eye.svg'
import _imports_2 from '@/app/ui/assets/svg/invisible.svg'


const _hoisted_1 = {
  "data-testid": "account-change-email-modal",
  style: {"width":"60vw"},
  class: "relative edit-body overflow-y-auto"
}
const _hoisted_2 = {
  key: 0,
  class: "text-red-lp-100 flex gap-x-2 text-12px mb-4",
  "data-testid": "account-change-email-error"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "warning"
}, null, -1)
const _hoisted_4 = { class: "flex justify-end gap-x-3 mt-8" }
const _hoisted_5 = {
  "data-testid": "account-change-email-password-modal",
  style: {"width":"60vw"},
  class: "relative edit-body overflow-y-auto"
}
const _hoisted_6 = { class: "inline-block relative w-full" }
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  alt: "",
  class: "h-6"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2,
  alt: "",
  class: "h-6"
}
const _hoisted_9 = {
  key: 0,
  class: "text-red-lp-100 flex gap-x-2 text-12px mb-4",
  "data-testid": "account-change-email-password-error"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "warning"
}, null, -1)
const _hoisted_11 = { class: "flex justify-end gap-x-3 mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      "model-value": _ctx.modelValue,
      persistent: true,
      title: _ctx.$t('Ubah Email'),
      "onUpdate:modelValue": _ctx.onUserCloseEmail
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Email Lama'),
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: true,
                "disable-background": true,
                "model-value": _ctx.currentEmail,
                "data-testid": "account-change-email-input-old",
                type: "email"
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Email Baru'),
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.newEmail,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newEmail = $event)),
                placeholder: _ctx.$t('Masukan email baru'),
                "data-testid": "account-change-email-input-new",
                type: "email"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.errorMessageEmail)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.errorMessageEmail), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_lp_button, {
              disabled: _ctx.isEmailSubmitDisabled || _ctx.isSubmittingEmail,
              "text-color": "white",
              "custom-class": "px-10",
              title: _ctx.$t('Simpan'),
              "data-testid": "account-change-email-button-save",
              onClick: _ctx.onSubmitEmail
            }, null, 8, ["disabled", "title", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "onUpdate:modelValue"]),
    _createVNode(_component_Dialog, {
      "model-value": _ctx.modelValuePassword,
      persistent: true,
      title: _ctx.$t('Masukkan password Anda'),
      "onUpdate:modelValue": _ctx.onUserClosePassword
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('Masukkan password'),
            class: "mb-4"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("input", {
                  type: _ctx.passwordType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                  placeholder: _ctx.$t('Masukkan password'),
                  class: "block appearance-none w-full bg-white border-2 px-4 py-3 pr-8 my-2 rounded leading-tight focus:outline-none",
                  "data-testid": "account-change-email-password-input"
                }, null, 8, ["type", "placeholder"]), [
                  [_vModelDynamic, _ctx.password]
                ]),
                _createVNode("button", {
                  type: "button",
                  class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-6 text-gray-500 focus:outline-none",
                  "data-testid": "account-change-email-password-toggle-visibility",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                }, [
                  (_ctx.passwordType === 'password')
                    ? (_openBlock(), _createBlock("img", _hoisted_7))
                    : (_openBlock(), _createBlock("img", _hoisted_8))
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.errorMessagePassword)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.errorMessagePassword), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_lp_button, {
              disabled: !_ctx.password || _ctx.isSubmittingPassword,
              "text-color": "white",
              "custom-class": "px-10",
              title: _ctx.$t('Simpan'),
              "data-testid": "account-change-email-password-button-save",
              onClick: _ctx.onSubmitPassword
            }, null, 8, ["disabled", "title", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title", "onUpdate:modelValue"])
  ], 64))
}